import {
    ADD_COMMENT,
    CLEAR_REVISION_INTERVAL_TIMER,
    CLICK_QUESTION_OPTION, CLICK_SUB_QUESTION_OPTION,
    DEACTIVATE_LOADING,
    DELETE_CHOOSEN_OPTIONS, GET_COMMENT,
    GET_REVISION,
    GET_REVISION_ERROR,
    GET_REVISION_LOADING,
    GO_NEXT_QUESTION_REVISION, GO_NEXT_SUB_QUESTION,
    GO_NTH_QUESTION_REVISION, GO_NTH_SUB_QUESTION,
    GO_PREVIOUS_QUESTION_REVISION,
    INCREMENT_REVISION_TIMER,
    SET_HOW_MANY_PAGINATION_BUTTONS_TO_CLICK,
    SET_INTERVAL_TIMER_REVISION,
    SET_VERIF_ANSWER_MODE_STATUS,
    VERIFY_USER_ANSWER
} from "../actions/actionTypes";


const initialState = {
    data :{},
    loading:true,
    error : null,
    actualQuestion : {},
    actualQuestionIndex :0 ,
    actualChoosenOptions : [],
    // array of True and False
    userScore : [],
    verifAnswerMode : false,
    actualQuestionsTimer : [],
    currentIntervalTimer : null,
    // infos related to the progression Buttons
    NbProgressionButtonsperClick : 5,
    howmanyPaginationButtonsToClick : 0,
    // for the CCQCM QUESTIONS
    actualSubQuestion : null,
    actualSubQuestionIndex : null ,
    // user score inside the actual ccqcm
    userSubScore : null, // [],
    // the choosen user options in all the subquestions of the ccqcm
    actualAllSubChoosenOptions: null, // []
    // the current Tab in the
    activeCcqcmTab : null,
    // [{questionId : id , comment : ''}]
}

export default function revisionReducer (state = initialState, action) {
    switch(action.type){
        case GET_REVISION:
            let constructedQuestionTimer=[];
            action.payload.questions.forEach(()=>{
                constructedQuestionTimer.push(0);
            });
            // WAITING TO GET A REAL QCM FROM THE DB
            let modifiedQuestions=[...action.payload.questions];
            let theFirstCCQCM = modifiedQuestions.find(question=> question.id === 313);
            let theFirstCCQCMIndex=modifiedQuestions.indexOf(theFirstCCQCM);
            console.log('index ccqcm =' , theFirstCCQCMIndex);
            let modifiedCCQCM ={...theFirstCCQCM ,
                        subquestions : [
                            modifiedQuestions.find(question=>question.id===317),
                            modifiedQuestions.find(question=>question.id===320),
                            modifiedQuestions.find(question=>question.id===321),
                            modifiedQuestions.find(question=>question.id===367)

                        ]
            };
            modifiedQuestions[theFirstCCQCMIndex]=modifiedCCQCM;
            return {
                ...state ,
                loading: false ,
                error: false,
                // data : action.payload,
                data : {...action.payload , questions : modifiedQuestions},
                actualQuestion: action.payload.questions[0],
                // that index will help us to jump from question to another
                actualQuestionIndex : 0,
                // help us to know which options are choosen we give them a blue background
                actualChoosenOptions : [],
                // initialized : [ 0 ,0 ,0 , ...]
                actualQuestionsTimer : constructedQuestionTimer,
                howmanyPaginationButtonsToClick: Math.min(action.payload.questions_count , state.NbProgressionButtonsperClick ),
                // Initializing CCQCM infos
                actualSubQuestion : action.payload.questions[0].type==='CCQCM' ? action.payload.questions[0].subquestions[0] : null,
                actualSubQuestionIndex : action.payload.questions[0].type==='CCQCM' ? 0 : null,
                userSubScore:  action.payload.questions[0].type==='CCQCM' ? [] : null,
                actualAllSubChoosenOptions :  action.payload.questions[0].type==='CCQCM' ? action.payload.questions[0].subquestions.map((subQ , index)=>{
                    return {
                        subquestionId : subQ.id ,
                        subquestionIndex : index,
                        actualChoosenOptions : []

                    }
                }) : null ,
                activeCcqcmTab: action.payload.questions[0].type==='CCQCM' ? 'q0' : null
            }
        case GET_REVISION_LOADING:
            return {
                ...state ,
                error : false ,
                loading: true
            }
        case GET_REVISION_ERROR :
            return {
                ...state,
                error : action.payload ,
                loading : false
            }
        case CLICK_QUESTION_OPTION:
            let newChoosenOptions = [...state.actualChoosenOptions];
            if(action.payload.questionType==='QCM'){
                // The option was choosen and now it's not
                if(newChoosenOptions.includes(action.payload.optionId)) {
                    newChoosenOptions = newChoosenOptions.filter(option => option !== action.payload)
                }
                // The option was not choosen and now it is
                else{
                    newChoosenOptions=newChoosenOptions.concat(action.payload.optionId);
                }
            }else if(action.payload.questionType==='QCU'){
                // The option was choosen and now it's not
                if(newChoosenOptions.includes(action.payload.optionId)) {
                    newChoosenOptions = []
                }
                // The option was not choosen and now it is
                else{
                    newChoosenOptions=[action.payload.optionId];
                }
            }
            return {
                ...state ,
                actualChoosenOptions: newChoosenOptions
            }
        // Choose an option inside ccqcm
        case CLICK_SUB_QUESTION_OPTION:
            let newChoosenSubOptions = [...state.actualAllSubChoosenOptions];
            let newActualSubQuestionOptions = newChoosenSubOptions.filter((subOptions)=>subOptions.subquestionId === action.payload.subquestionId)[0].actualChoosenOptions;
            console.log('actual SubQuestion its actual choosen options : ', newActualSubQuestionOptions);
            if(action.payload.questionType==='QCM'){
                // The option was choosen and now it's not
                if(newActualSubQuestionOptions.includes(action.payload.optionId)) {
                    newActualSubQuestionOptions = newActualSubQuestionOptions.filter(option => option !== action.payload.optionId)
                }
                // The option was not choosen and now it is
                else{
                    newActualSubQuestionOptions=newActualSubQuestionOptions.concat(action.payload.optionId);
                }
            }else if(action.payload.questionType==='QCU'){
                // The option was choosen and now it's not
                if(newActualSubQuestionOptions.includes(action.payload.optionId)) {
                    newActualSubQuestionOptions = []
                }
                // The option was not choosen and now it is
                else{
                    newActualSubQuestionOptions=[action.payload.optionId];
                }
            }
            return {
                ...state,
                actualAllSubChoosenOptions: state.actualAllSubChoosenOptions.map(actualAllSubChoosenOptions=>{
                    if(actualAllSubChoosenOptions.subquestionId !== action.payload.subquestionId){
                        return actualAllSubChoosenOptions
                    }else{
                        return {
                            ...actualAllSubChoosenOptions,
                            actualChoosenOptions: newActualSubQuestionOptions
                        }
                    }
                })
            }
        case GO_NEXT_QUESTION_REVISION:
            return {
                ...state ,
                actualQuestion: state.data.questions[state.actualQuestionIndex+1],
                actualQuestionIndex : state.actualQuestionIndex+1,
                actualChoosenOptions : [],
                // eventual changemet if the question is CCQCM
                actualSubQuestion : state.data.questions[state.actualQuestionIndex+1].type==='CCQCM' ? state.data.questions[state.actualQuestionIndex+1].subquestions[0] : null,
                actualSubQuestionIndex : action.payload.questions[state.actualQuestionIndex+1].type==='CCQCM' ? 0 : null
            }
        case GO_PREVIOUS_QUESTION_REVISION:
            return {
                ...state ,
                actualQuestion: state.data.questions[state.actualQuestionIndex-1],
                actualQuestionIndex : state.actualQuestionIndex-1,
                actualChoosenOptions : [],
            }
        // THE user clicked  'Verifier la reponse' and I have to decide if what he did is correct or wrong
        case VERIFY_USER_ANSWER :
            let theUserIsCorrect =false;
            let heChoosedaWrongOption=false;
            let howManyCorrectHeChoosed=0;
            if(state.actualQuestion.type !== 'CCQCM'){
                state.actualChoosenOptions.forEach(optionId=>{
                    let theOption = state.actualQuestion.options.filter(option=>option.id===optionId)[0];
                    console.log('The user choose that option :' , theOption);
                    if(theOption.is_correct){
                        howManyCorrectHeChoosed++;
                    }else{
                        heChoosedaWrongOption=true;
                    }
                });
                if(!heChoosedaWrongOption && state.actualQuestion.correct_options_count === howManyCorrectHeChoosed ){
                    theUserIsCorrect=true;
                }
                return {
                    ...state ,
                    userScore: [...state.userScore].concat({questionIndex : state.actualQuestionIndex , correct : theUserIsCorrect})
                }
            }else{
                // I HAVE TO DO THE CASE OF VERIFY FOR CCQCM
                let actualSubQuestionChoosenOptions = state.actualAllSubChoosenOptions.filter(subchoosen=>subchoosen.subquestionId === state.actualSubQuestion.id)[0].actualChoosenOptions;
                console.log(' actual sub choosen =', actualSubQuestionChoosenOptions);
                actualSubQuestionChoosenOptions.forEach(optionId=>{
                    let theOption = state.actualSubQuestion.options.filter(option=>option.id===optionId)[0];
                    console.log('The user choose that option :' , theOption);
                    if(theOption.is_correct){
                        howManyCorrectHeChoosed++;
                    }else{
                        heChoosedaWrongOption=true;
                    }
                });
                if(!heChoosedaWrongOption && state.actualSubQuestion.correct_options_count === howManyCorrectHeChoosed ){
                    theUserIsCorrect=true;
                }
                return {
                    ...state,
                    userSubScore: [...state.userSubScore].concat({questionId : state.actualSubQuestion.id , correct : theUserIsCorrect})
                }
            }

        case GO_NTH_QUESTION_REVISION:
            return {
                ...state ,
                actualQuestion: state.data.questions[action.payload],
                actualQuestionIndex : action.payload,
                actualChoosenOptions : [],
                // eventual changemet if the question is CCQCM
                actualSubQuestion : state.data.questions[action.payload].type==='CCQCM' ? state.data.questions[action.payload].subquestions[0] : null,
                actualSubQuestionIndex : state.data.questions[action.payload].type==='CCQCM' ? 0 : null,
                userSubScore:  state.data.questions[action.payload].type==='CCQCM' ? [] : null,
                actualAllSubChoosenOptions :  state.data.questions[action.payload].type==='CCQCM' ? state.data.questions[action.payload].subquestions.map((subQ , index)=>{
                    return {
                        subquestionId : subQ.id ,
                        subquestionIndex : index,
                        actualChoosenOptions : []

                    }
                }) : null
            }
        case DELETE_CHOOSEN_OPTIONS:
            return {
                ...state ,
                actualChoosenOptions: []
            }
        case SET_VERIF_ANSWER_MODE_STATUS:
            return {
                ...state ,
                verifAnswerMode : action.payload
            }
        case INCREMENT_REVISION_TIMER:
            let newActualQuestionsTimer= [...state.actualQuestionsTimer];
            newActualQuestionsTimer[action.payload]++
            return {
                ...state,
                actualQuestionsTimer: newActualQuestionsTimer
            }
        case SET_INTERVAL_TIMER_REVISION :
            return{
                ...state ,
                currentIntervalTimer : action.payload
            }
        case CLEAR_REVISION_INTERVAL_TIMER:
            clearInterval(state.currentIntervalTimer);
            return {
                ...state ,
                currentIntervalTimer: null
            }
        // FOR PROGRESSION BUTTONS :
        case SET_HOW_MANY_PAGINATION_BUTTONS_TO_CLICK:
            return {
                ...state,
                howmanyPaginationButtonsToClick: action.payload
            }
        // FOR CCQCM
        case GO_NTH_SUB_QUESTION:
            console.log('GO TO INDEX : ' , action.payload);
            return {
                ...state ,
                actualSubQuestion : state.actualQuestion.subquestions[action.payload] ,
                actualSubQuestionIndex : action.payload
            }
        case GO_NEXT_SUB_QUESTION:
            return {
                ...state ,
                actualSubQuestionIndex: (state.actualSubQuestionIndex+1)% state.actualQuestion.subquestions.length,
                actualSubQuestion: state.actualQuestion.subquestions[(state.actualSubQuestionIndex+1)% state.actualQuestion.subquestions.length]
            }
        default :
            return state
    }
}

